export function sendToExtension(type, payload) {
  const callback = window.__ddBrowserSdkExtensionCallback;
  if (callback) {
    callback({
      type,
      payload
    });
  }
}
